import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card"
import { FileText, FileSearch, Info } from "lucide-react"
import { Badge } from "@/components/ui/badge"
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group"
import { Label } from "@/components/ui/label"
import { type AIMonitorConfig } from "@/types/config"

interface CostSettingsProps {
  costControl: AIMonitorConfig['CostControl']
  onUpdate: (config: Partial<AIMonitorConfig>) => void
  isLoading?: boolean
}

export function CostSettings({ costControl, onUpdate, isLoading }: CostSettingsProps) {
  return (
    <Card>
      <CardHeader>
        <div className="flex justify-between items-start">
          <CardTitle className="flex items-center gap-2">
            <FileSearch className="h-5 w-5 text-blue-500" />
            Analysis Scope
          </CardTitle>
          <Badge variant="secondary" className="flex items-center gap-1">
            <Info className="h-3 w-3" />
            Using Claude 3.5 Haiku
          </Badge>
        </div>
        <CardDescription>
          Control analysis depth and associated costs
        </CardDescription>
      </CardHeader>
      <CardContent>
        <RadioGroup
          value={costControl}
          onValueChange={(value) => onUpdate({ CostControl: value as AIMonitorConfig['CostControl'] })}
          disabled={isLoading}
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="full_text" id="full_text" />
            <Label htmlFor="full_text" className="flex items-center gap-2">
              <FileText className="h-4 w-4" />
              Full Bill Text
            </Label>
          </div>
          <div className="flex items-center space-x-2 mt-4">
            <RadioGroupItem value="synopsis" id="synopsis" />
            <Label htmlFor="synopsis" className="flex items-center gap-2">
              <FileSearch className="h-4 w-4" />
              Synopsis Only
            </Label>
          </div>
        </RadioGroup>
      </CardContent>
    </Card>
  )
}